import { createDefault } from "../utils/ConstUtils";

export default createDefault([
  { value: 920000000001, text: "エフトランス", enum: "FT" },
  { value: 920000000002, text: "カフェレオ", enum: "CAFEREO" },
]);
